import React, { useEffect, useState } from 'react';

export default function ParallaxBackground() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const prefersReducedMotion = typeof window !== 'undefined' 
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches 
    : false;

  if (prefersReducedMotion) {
    return (
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-1/4 w-96 h-96 bg-primary-200/30 rounded-full blur-3xl" />
        <div className="absolute top-1/3 -right-1/4 w-96 h-96 bg-primary-300/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-primary-400/20 rounded-full blur-3xl" />
      </div>
    );
  }

  const parallaxSpeed1 = scrollY * 0.3;
  const parallaxSpeed2 = scrollY * 0.5;
  const parallaxSpeed3 = scrollY * 0.2;

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      <div
        className="absolute top-0 -left-1/4 w-96 h-96 bg-primary-200/30 rounded-full blur-3xl transition-transform duration-300 ease-out"
        style={{ transform: `translateY(${parallaxSpeed1}px) translateX(${parallaxSpeed1 * 0.5}px)` }}
      />
      <div
        className="absolute top-1/3 -right-1/4 w-96 h-96 bg-primary-300/20 rounded-full blur-3xl transition-transform duration-300 ease-out"
        style={{ transform: `translateY(${parallaxSpeed2}px) translateX(${-parallaxSpeed2 * 0.3}px)` }}
      />
      <div
        className="absolute bottom-0 left-1/2 w-96 h-96 bg-primary-400/20 rounded-full blur-3xl transition-transform duration-300 ease-out"
        style={{ transform: `translateY(${-parallaxSpeed3}px) translateX(${parallaxSpeed3 * 0.4}px)` }}
      />
    </div>
  );
}

